import React from 'react';
import SurveyPage from '../components/SurveyPage';
import SurveyTitleArea from '../components/SurveyTitleArea';
import SurveySection from '../components/SurveySection';
import SurveyElement from '../components/SurveyElement';
import SurveyContentContainer from '../components/SurveyContentContainer';
import SurveyGridHeader from '../components/GridComponents/SurveyGridHeader';
import SurveyGridBody from '../components/GridComponents/SurveyGridBody';
import SurveyGridRow from '../components/GridComponents/SurveyGridRow';
import {
  CommonResponses,
  ElementType,
  SelectCombos,
} from '../Enums/constants';
import SurveyConditionalSegment from '../components/SurveyConditionalSegment';


export const PabsCustomerExperienceTab = () => {
  return (
    <SurveyPage>
      <SurveyTitleArea />
      <SurveyContentContainer>
        <SurveySection
          id="1"
          labelText="Member Experience Surveying"
        >
          <SurveyElement
            questionNumber="94"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO}
            name="GenSurvyn"
            labelText="Did you send any satisfaction or member experience surveys in your most recent fiscal year?"
          />
          <SurveyConditionalSegment
            showIf={{
              GenSurvyn: { not: CommonResponses.NO }
            }}
          >
            <SurveyElement
              questionNumber="94.a"
              labelText="Did you survey a sample of the following customer groups:"
              subQuestion
            />
            <SurveyElement
              questionNumber="94.a.a1"
              inputType={ElementType.SELECT}
              options={SelectCombos.YES_NO}
              name="GenSurvActives"
              labelText="Active members?"
              doubleSubQuestion
            />
            <SurveyElement
              questionNumber="94.a.a2"
              inputType={ElementType.SELECT}
              options={SelectCombos.YES_NO}
              name="GenSurvAnn"
              labelText="Annuitants?"
              doubleSubQuestion
            />
            <SurveyElement
              questionNumber="94.a.a3"
              inputType={ElementType.SELECT}
              options={SelectCombos.YES_NO}
              name="GenSurvInactives"
              labelText="Inactive members?"
              doubleSubQuestion
            />
            <SurveyElement
              questionNumber="94.b"
              inputType={ElementType.SELECT}
              options={SelectCombos.YES_NO}
              name="ActivitySurvyn"
              labelText="Did you send a survey focused on a sample of members that recently engaged with your plan?"
              subQuestion
            />

            <SurveyConditionalSegment
              showIf={{
                ActivitySurvyn: { not: CommonResponses.NO }
              }}
            >
              <SurveyElement inputType="grid" styleName={"dataTable customerExperience"}>
                <SurveyGridHeader>
                  <SurveyElement
                    labelText=""
                    inputType={ElementType.LABEL}
                  />
                  <SurveyElement
                    labelText="Satisfaction or NPS "
                    inputType={ElementType.LABEL}
                  />
                  <SurveyElement
                    labelText="Effort (CES) "
                    inputType={ElementType.LABEL}
                  />
                </SurveyGridHeader>
                <SurveyGridBody>
                  <SurveyGridRow>
                    <SurveyElement
                      questionNumber="94.b.b1"
                      labelText="Calls"
                      inputType={ElementType.LABEL}
                    />
                    <SurveyElement
                      inputType={ElementType.SELECT}
                      options={SelectCombos.YES_NO}
                      name="SatSurvNPSCalls"
                      pageName="CustomerExperience"
                    />
                    <SurveyElement
                      inputType={ElementType.SELECT}
                      options={SelectCombos.YES_NO}
                      name="CESCalls"
                      pageName="CustomerExperience"
                    />
                  </SurveyGridRow>
                  <SurveyGridRow>
                    <SurveyElement
                      questionNumber="94.b.b2"
                      labelText="Self-service website"
                      inputType={ElementType.LABEL}
                      name="" />
                    <SurveyElement
                      inputType={ElementType.SELECT}
                      options={SelectCombos.YES_NO_NA}
                      name="SatSurvNPSWebsite"
                      pageName="CustomerExperience"
                    />
                    <SurveyElement
                      inputType={ElementType.SELECT}
                      options={SelectCombos.YES_NO_NA}
                      name="CESWebsite"
                      pageName="CustomerExperience"
                    />
                  </SurveyGridRow>
                  <SurveyGridRow>
                    <SurveyElement
                      questionNumber="94.b.b3"
                      labelText="1-on-1 counseling"
                      inputType={ElementType.LABEL}
                    />
                    <SurveyElement
                      inputType={ElementType.SELECT}
                      options={SelectCombos.YES_NO_NA}
                      name="SatSurvNPS1on1"
                      pageName="CustomerExperience"
                    />
                    <SurveyElement
                      inputType={ElementType.SELECT}
                      options={SelectCombos.YES_NO_NA}
                      name="CES1on1Counseling"
                      pageName="CustomerExperience"
                    />
                  </SurveyGridRow>
                  <SurveyGridRow>
                    <SurveyElement
                      questionNumber="94.b.b4"
                      labelText="Member presentations"
                      inputType={ElementType.LABEL}
                    />
                    <SurveyElement
                      inputType={ElementType.SELECT}
                      options={SelectCombos.YES_NO_NA}
                      name="SatSurvNPSPresentations"
                      pageName="CustomerExperience"
                    />
                    <SurveyElement
                      inputType={ElementType.SELECT}
                      options={SelectCombos.YES_NO_NA}
                      name="CESPresentations"
                      pageName="CustomerExperience"
                    />
                  </SurveyGridRow>
                  <SurveyGridRow>
                    <SurveyElement
                      questionNumber="94.b.b5"
                      labelText="New member enrollment"
                      inputType={ElementType.LABEL}
                    />
                    <SurveyElement
                      inputType={ElementType.SELECT}
                      options={SelectCombos.YES_NO}
                      name="SatSurvNPSNewjob"
                      pageName="CustomerExperience"
                    />
                    <SurveyElement
                      inputType={ElementType.SELECT}
                      options={SelectCombos.YES_NO}
                      name="CESNewActive"
                      pageName="CustomerExperience"
                    />
                  </SurveyGridRow>
                  <SurveyGridRow>
                    <SurveyElement
                      questionNumber="94.b.b6"
                      labelText="Leaving the pension plan"
                      inputType={ElementType.LABEL}
                    />
                    <SurveyElement
                      inputType={ElementType.SELECT}
                      options={SelectCombos.YES_NO}
                      name="SatSurvNPSExitPlan"
                      pageName="CustomerExperience"
                    />
                    <SurveyElement
                      inputType={ElementType.SELECT}
                      options={SelectCombos.YES_NO}
                      name="CESExitPlan"
                      pageName="CustomerExperience"
                    />
                  </SurveyGridRow>
                  <SurveyGridRow>
                    <SurveyElement
                      questionNumber="94.b.b7"
                      labelText="Disability"
                      inputType={ElementType.LABEL}
                    />
                    <SurveyElement
                      inputType={ElementType.SELECT}
                      options={SelectCombos.YES_NO_NA}
                      name="SatSurvNPSDisability"
                      pageName="CustomerExperience"
                    />
                    <SurveyElement
                      inputType={ElementType.SELECT}
                      options={SelectCombos.YES_NO_NA}
                      name="CESDisability"
                      pageName="CustomerExperience"
                    />
                  </SurveyGridRow>
                  <SurveyGridRow>
                    <SurveyElement
                      questionNumber="94.b.b8"
                      labelText="Retirement experience"
                      inputType={ElementType.LABEL}
                    />
                    <SurveyElement
                      inputType={ElementType.SELECT}
                      options={SelectCombos.YES_NO}
                      name="SatSurvNPSRetire"
                      pageName="CustomerExperience"
                    />
                    <SurveyElement
                      inputType={ElementType.SELECT}
                      options={SelectCombos.YES_NO}
                      name="CESRetire"
                      pageName="CustomerExperience"
                    />
                  </SurveyGridRow>
                </SurveyGridBody>
              </SurveyElement>
            </SurveyConditionalSegment>
          </SurveyConditionalSegment>
        </SurveySection>
      </SurveyContentContainer>
    </SurveyPage>
  );
};